import React, { useContext, useState } from "react";
import { CartContext } from "../context/CartContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Checkout = () => {
  const { cart, setCart } = useContext(CartContext); // 👈 need setCart
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    address: "",
  });

  const total = cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleOrder = () => {
    if (!form.name || !form.email || !form.address) {
      toast.error("Please fill all fields");
      return;
    }

    if (cart.length === 0) {
      toast.error("Cart is empty");
      return;
    }

    toast.success("Order placed successfully 🎉");

    // ✅ Clear cart
    setCart([]);

    // ✅ Redirect after 2 sec
    setTimeout(() => {
      navigate("/");
    }, 2000);
  };

  return (
    <div style={{ padding: "30px", maxWidth: "800px", margin: "auto" }}>
      <h1>Checkout</h1>

      {/* 🧑 Customer Info */}
      <div style={{ marginBottom: "20px" }}>
        <input
          type="text"
          name="name"
          placeholder="Full Name"
          value={form.name}
          onChange={handleChange}
          style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
        />

        <input
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
        />

        <textarea
          name="address"
          placeholder="Address"
          value={form.address}
          onChange={handleChange}
          style={{ width: "100%", padding: "10px" }}
        />
      </div>

      {/* 🧾 Order Summary */}
      <h2>Order Summary</h2>
      {cart.map((item) => (
        <div
          key={item.id}
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <span>
            {item.title} x {item.quantity}
          </span>
          <span>${(item.price * item.quantity).toFixed(2)}</span>
        </div>
      ))}

      <hr />

      <h2>Total: ${total.toFixed(2)}</h2>

      {/* 💳 Order Button */}
      <button
        onClick={handleOrder}
        disabled={cart.length === 0}
        style={{
          marginTop: "20px",
          padding: "12px",
          width: "100%",
          backgroundColor: cart.length === 0 ? "#ccc" : "#27ae60",
          color: "white",
          border: "none",
          fontSize: "16px",
          cursor: cart.length === 0 ? "not-allowed" : "pointer",
          borderRadius: "5px",
        }}
      >
        Place Order
      </button>
    </div>
  );
};

export default Checkout;